import { useTranslation } from 'react-i18next';
import Icon from '../Icon/Icon';
import styles from './LabPill.module.css';

export default function LabPill() {
    const { t } = useTranslation();

    return (
        <span className={styles.pill}>
            <Icon name="flask" className={styles.icon} />
            {t('ownership.lab')}
        </span>
    );
}
